import { render, staticRenderFns } from "./Repasses.vue?vue&type=template&id=a169b52e&"
import script from "./Repasses.vue?vue&type=script&lang=js&"
export * from "./Repasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports